module.exports = __webpack_public_path__ + "img/1721-1724.10cd1c4c.jpg";